// src/admin/pages/AdminAudit.jsx
import React, { useEffect, useState } from "react";
import { listAuditLogs } from "../../api/adminAuditApi";

export default function AdminAudit() {
  const [page, setPage] = useState(0);
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(true);

  const load = async (p) => {
    setBusy(true);
    try {
      setData(await listAuditLogs(p, 50));
      setPage(p);
    } finally {
      setBusy(false);
    }
  };
 
  useEffect(() => { load(0); }, []);

  const rows = data?.content || [];

  return (
    <div>
      <h2 className="text-2xl font-extrabold tracking-tight">Audit Logs</h2>
      <p className="mt-2 text-sm text-slate-600">
        Every admin change is tracked here.
      </p>

      <div className="mt-5 rounded-2xl border border-slate-200 overflow-hidden">
        <div className="grid grid-cols-12 bg-slate-50 px-4 py-3 text-xs font-semibold text-slate-600">
          <div className="col-span-2">Time</div>
          <div className="col-span-2">Admin</div>
          <div className="col-span-3">Action</div>
          <div className="col-span-2">Entity</div>
          <div className="col-span-3">Reason</div>
        </div>

        {busy ? (
          <div className="p-4 text-sm text-slate-600">Loading…</div>
        ) : rows.length ? (
          rows.map((r) => (
            <div key={r.id} className="grid grid-cols-12 px-4 py-3 border-t border-slate-200 text-sm">
              <div className="col-span-2 text-xs text-slate-600">{String(r.createdAt || "").replace("T"," ").slice(0,19)}</div>
              <div className="col-span-2 text-xs text-slate-600">{r.adminId ?? "—"}</div>
              <div className="col-span-3 font-semibold">{r.actionKey}</div>
              <div className="col-span-2 text-xs text-slate-600">{r.entityType ?? "—"} #{r.entityId ?? "—"}</div>
              <div className="col-span-3 text-xs text-slate-600 line-clamp-2">{r.reason ?? "—"}</div>
            </div>
          ))
        ) : (
          <div className="p-4 text-sm text-slate-600">No logs.</div>
        )}
      </div>

      <div className="mt-4 flex items-center gap-2">
        <button
          className="rounded-xl border border-slate-200 px-3 py-2 text-sm font-semibold hover:bg-slate-50 disabled:opacity-50"
          disabled={page <= 0}
          onClick={() => load(page - 1)}
        >
          Prev
        </button>
        <button
          className="rounded-xl border border-slate-200 px-3 py-2 text-sm font-semibold hover:bg-slate-50"
          onClick={() => load(page + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
}
